export default __webpack_public_path__ + "static/media/classfeats-back.cf5f66d0.svg";